import { Col, Divider, Row } from "antd";
import { useMemo } from "react";
import { OrderPackageInfo } from "../../../../../../model/OrderManagement/Package";
import { sumPrice } from "../../../../../../shared/utils/Numbers";
import { CustomCard } from "../../../Detail/Card.styled";
import {
  ProductCategoryStatusTag,
  ProductCategoryStatusType,
} from "../../../Tags/ProductCategoryStatus";
import { ProductThumbnail } from "../../RepairCard/Thumbnail";
import { ProductOptionsInfoCardForm } from "./Item";

interface ProductItemInfoFormProps {
  dataSource?: Array<OrderPackageInfo>;
  type?: ProductCategoryStatusType | undefined;
  showPrice?: boolean;
}

/**
 * 상품유형별 상품옵션 정보 - 카드형
 * @param param0
 * @returns
 */
export const ProductItemInfoForm: React.FC<ProductItemInfoFormProps> = ({
  dataSource,
  type,
  showPrice = true,
}) => {
  const media = useMemo(
    () => dataSource?.[0].media?.bufferFullUrl,
    [dataSource]
  );

  return (
    <CustomCard bodyStyle={{ padding: 16 }}>
      <Row gutter={[16, 12]} wrap={false}>
        <Col flex="none">{media && <ProductThumbnail src={media} />}</Col>
        <Col flex="auto">
          <Row gutter={[16, 12]} style={{ width: "100%" }}>
            {type && (
              <Col span={24}>
                <ProductCategoryStatusTag value={type} />
              </Col>
            )}
            {dataSource?.map((item, idx, arr) => (
              <>
                <Col span={24}>
                  <ProductOptionsInfoCardForm
                    title={item.productOptionValue}
                    erpCode={item.erpCode}
                    amount={item.amount}
                    {...(showPrice === true && {
                      unitPrice: +(sumPrice(item.price, item.tax)(false) || 0),
                    })}
                  />
                </Col>
                {idx !== arr.length - 1 && (
                  <Divider dashed style={{ margin: 0 }} />
                )}
              </>
            ))}
          </Row>
        </Col>
      </Row>
    </CustomCard>
  );
};
